import React, { useState, useEffect } from "react";
import {
  Select,
  Form,
  Input,
  InputNumber,
  Row,
  Col,
  Upload,
  Button,
  Divider,
} from "antd";
import { DeleteFilled, UploadOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import "./product.css";

function UpdateProduct() {
  const { id } = useParams();
  let navigate = useNavigate();
  const { Option } = Select;
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [fields, setFields] = useState([]);
  const [productId, setProductId] = useState([]);

  useEffect(() => {
    fetchPageDetails();
  }, [id]);

  const fetchPageDetails = async () => {
    try {
      const { data } = await axios
        .get("/view-product", {
          params: {
            id: id,
          },
        })
        .catch((error) => {
          Helper.ErrorHanlder(error);
        });
      if (data && data.data) {
        form.setFieldsValue({
          price: data.data.price,
          points: data.data.points,
          courier: data.data.courier,
          webPrice: data.data.webPrice,
          name: data.data.BillingProduct.name,
          desc: data.data.BillingProduct.desc,
          catalogue: data.data.BillingProduct.catalogue,
          demoVideo: data.data.BillingProduct.demoVideo,
          sizeRef: data.data.BillingProduct.sizeRef,
          howToOrderLabel: data.data.BillingProduct.howToOrderLabel,
          courierType: data.data.BillingProduct.courierType,
          sizeRefLabel: data.data.BillingProduct.sizeRefLabel,
          catalogueLabel: data.data.BillingProduct.catalogueLabel,
          discount: data.data.BillingProduct.discount,
        });
        setProductId(data.data.productId);
        setFields(data.data.BillingProduct.inputs);
        setFileList(data.data.BillingProduct.images);
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleAddField = () => {
    setFields((prev) => [
      ...prev,
      {
        label: "",
        type: "text",
        required: true,
      },
    ]);
  };

  const handleInputChange = (index, value) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, label: value } : field,
    );
    setFields(updatedFields);
  };

  const handleTypeChange = (index, value) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, type: value } : field,
    );
    setFields(updatedFields);
  };

  const handleRequiredChange = (index, value) => {
    const updatedFields = fields.map((field, i) =>
      i === index ? { ...field, required: value } : field,
    );
    setFields(updatedFields);
  };

  const handleRemoveField = (indexToRemove) => {
    const updatedFields = fields.filter((_, index) => index !== indexToRemove);
    setFields(updatedFields);
  };

  const ImageUpload = async ({ file, onSuccess }) => {
    const formData = new FormData();
    formData.append("image", file);

    try {
      const { data } = await axios.post("web-image-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (data && data?.files?.[0]) {
        const filename = data.files[0];

        setFileList((prev) => [...prev, filename]);

        onSuccess("ok");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  const handleSubmit = async () => {
    try {
      let obj = {
        ...{ id: id, productId: productId, images: fileList, inputs: fields },
        ...form.getFieldsValue(),
      };
      if (obj.price) {
        const data = await axios
          .patch("/product-update", obj)
          .catch((error) => {
            Helper.ErrorHanlder(error);
          });
        if (data && data.data) navigate("/products");
      }
    } catch (error) {
      Helper.ErrorHanlder(error);
    }
  };

  return (
    <div className="product-edit-pg">
      <h2>Update Products</h2>
      <Divider />
      <div className="product-details">
        <Form name="basic" form={form} layout={"vertical"} autoComplete="off">
          <Row gutter={12}>
            <Col md={24}>
              <Form.Item label="Name" name="name">
                <Input onChange={(e) => {}} />
              </Form.Item>
            </Col>
            <Col md={6}>
              <Form.Item label="Price" name="price">
                <InputNumber className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={6}>
              <Form.Item label="Points" name="points">
                <InputNumber className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={6}>
              <Form.Item label="Retail Price" name="webPrice">
                <InputNumber className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={6}>
              <Form.Item label="Courier" name="courier">
                <InputNumber className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Catalogue" name="catalogue">
                <Input className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Order Demo Video" name="demoVideo">
                <Input className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Size Ref" name="sizeRef">
                <Input className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Text For Catalogue" name="catalogueLabel">
                <Input className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item
                label="Text For Order Demo Video"
                name="howToOrderLabel"
              >
                <Input className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>

            <Col md={8}>
              <Form.Item label="Text For Size Ref" name="sizeRefLabel">
                <Input className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={10}>
              <Form.Item label="Courier Type" name="courierType">
                <Select
                  className="text-start"
                  optionFilterProp="children"
                  defaultValue={"individual"}
                  onChange={(input) => {}}
                >
                  <Option value={"individual"}>Individual Qty</Option>
                  <Option value={"all"}>All Qty</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col md={6}>
              <Form.Item label="Discount(%)" name="discount">
                <InputNumber className="w-100" onChange={(input) => {}} />
              </Form.Item>
            </Col>
            <Col md={16}>
              <Form.Item label="Description" name="desc">
                <ReactQuill theme="snow" />
              </Form.Item>
              <div className="add-product-fields">
                <label>Fields Details</label>
                <Button type="primary" onClick={() => handleAddField()}>
                  Add
                </Button>
              </div>
              {fields.map((val, index) => (
                <div
                  key={index}
                  style={{
                    margin: "20px 0",
                    display: "flex",
                    flexWrap: "wrap",
                  }}
                >
                  <Col md={12}>
                    <Input
                      value={val.label}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                    />
                  </Col>
                  <Col md={6} style={{ textAlign: "start" }}>
                    <Select
                      value={val.type}
                      style={{ width: "100%" }}
                      onChange={(value) => handleTypeChange(index, value)}
                      options={[
                        { value: "text", label: "Text" },
                        { value: "date", label: "Date" },
                        { value: "image", label: "Image" },
                      ]}
                    />
                  </Col>
                  <Col md={4} style={{ textAlign: "start" }}>
                    <Select
                      value={val.required}
                      style={{ width: "100%" }}
                      onChange={(value) => handleRequiredChange(index, value)}
                      options={[
                        { value: true, label: "Required" },
                        { value: false, label: "Optional" },
                      ]}
                    />
                  </Col>
                  <Col md={2}>
                    <DeleteFilled
                      style={{
                        color: "red",
                        fontSize: "18px",
                        cursor: "pointer",
                        marginTop: "5px",
                      }}
                      onClick={() => handleRemoveField(index)}
                    />
                  </Col>
                </div>
              ))}
            </Col>
            <Col md={8}>
              <Form.Item label="Images">
                <div
                  style={{
                    border: "1px dashed grey",
                    padding: " 30px 10px",
                    borderRadius: "2px",
                  }}
                >
                  <Upload
                    customRequest={ImageUpload}
                    listType="picture"
                    multiple
                    name="image"
                    maxCount={3}
                    fileList={fileList.map((fileName, index) => ({
                      uid: `${index}`,
                      name: fileName,
                      status: "done",
                      url: `https://thecharmingtreasure.in/uploads/${fileName}`,
                    }))}
                    onRemove={async (file) => {
                      try {
                        const filename = file.name;

                        setFileList((prev) =>
                          prev.filter((name) => name !== filename),
                        );

                        await axios.post("/delete-image", { filename });

                        return true;
                      } catch (error) {
                        return false;
                      }
                    }}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                </div>
              </Form.Item>
            </Col>
            <Col md={24} style={{ textAlign: "end", marginTop: "50px" }}>
              <Button
                type="primary"
                onClick={() => handleSubmit()}
                size="large"
              >
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default UpdateProduct;
